<template>
  <div>
    <user-form ref="CreateForm" mode="create"/>
    <user-form ref="UpdateForm" mode="update"/>
    <user-form ref="ResetForm" mode="reset"/>


    <md-card class="searchPanel">
      <md-card-content>
        <!---
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-25 md-small-size-100">
            <md-field>
              <label>Username</label>
              <md-input v-model="searchRequest.fromUsername" @keyup.enter="doSearch"/>
            </md-field>
          </div>
          <div class="md-layout-item md-size-25 md-small-size-100">
            <md-field>
              <label>To</label>
              <md-input v-model="searchRequest.toUsername" @keyup.enter="doSearch"/>
            </md-field>
          </div>
          <div class="md-layout-item md-size-25 md-small-size-100">
            <master-data-select
                label="Category"
                group="UserCategory"
                v-model="searchRequest.category"
            />

            <driver-group-select
                label="Driver Group"
                v-model="searchRequest.driverGroup">
            </driver-group-select>
          </div>
          <div class="md-layout-item md-size-25 md-small-size-100">
            <master-data-select
                label="Company"
                group="Company"
                v-model="searchRequest.companyId"
            />

            <md-checkbox v-model="showDisabled">
              <label>Show Disabled Users</label>
            </md-checkbox>
          </div>
        </div>
      -->
        <div class="MFA" v-if="authenticatedUser">
            <div class="MFAHeader">
               User MFA Info
            </div>
            <div class="MFAInnerBox">
              <md-field class="MFAContent">
                 <label>Secret Code</label>
                 <md-input v-model="authForm.secretCode" :disabled="disableGenTOTP"></md-input>
              </md-field>
              <md-field class="MFAContent">
                 <label>User MFA Preference</label>
                 <md-input class="UserPreference" v-model="authForm.userMFAPreference" disabled></md-input>
              </md-field>
            </div>
            <div class="MFAEnabled">
              <md-checkbox v-model="UserMFAEnabled" disabled>MFA Endabled</md-checkbox>  
            </div>
        </div>
      </md-card-content>

      <md-card-actions class="UserButtons">
        <calling-api :paths="['/api/w/users','/api/w/excel/generate']">
          <md-button @click="doSetupTOTP" class="md-primary md-raised" :disabled="disableGenTOTP">TOTP MFA</md-button>
          <md-button @click="doVerifyTOTP" class="md-primary md-raised" :disabled="disableGenTOTP">Verify</md-button>
          <md-button @click="doGetUserMFAPreference" class="md-primary md-raised">Refresh</md-button>
          <!--<md-button @click="doGetLoginUserInfo" class="md-primary md-raised" v-if="getPermission.acnit.view">Login User</md-button>-->
          <md-button @click="doClear" class="md-raised">Clear</md-button>
        </calling-api>
      </md-card-actions>
    </md-card>

  <div v-if="disableGenTOTP == false">  
     <div class="QRCodeText" v-if="authForm.otpauthURL && authForm.otpauthURL != ''">
        Please scan below QR code and add to your Authenticator App
     </div> 
     <div v-if="authForm.otpauthURL && authForm.otpauthURL != ''" class="MFAQR">
       <qrcode-vue :value="authForm.otpauthURL"/>
     </div>
  </div>
   <!--
    <div>
      <md-button @click="toggleCreate" class="md-fab-bottom-right md-fab md-primary">
        <md-icon>add</md-icon>
      </md-button>
    </div>
  -->

  <!--
    <pagination :items="getUsersToDisplay">
      <template slot-scope="{pageItems}">
        <md-card class="data-table-container">
          <div class="outer-container">
            <div class="inner-container">
              <div class="table-header">
                <table id="headertable">
                  <thead>
                  <tr>
                    <th class="header-cell w5" v-if="getPermission.users.edit"></th>
                    <th class="header-cell w10">
                      <sort :sort.sync="sort" field="username">
                        ID
                      </sort>
                    </th>
                    <th class="header-cell w3">MFA</th>
                    <th class="header-cell w10">Name</th>
                    <th class="header-cell w5">Category</th>
                    <th class="header-cell w10">Company</th>
                    <th class="header-cell w5">Country</th>
                    <th class="header-cell w5">Mobile No</th>
                    <th class="header-cell w7">MFA Mobile No</th>
                    <th class="header-cell w10">Email</th>
                    <th class="header-cell w10">Sales office</th>
                    <th class="header-cell w10">Rec Window</th>
                    <th class="header-cell w5">Driver Group</th>
                    <th class="header-cell w5">Driver Region</th>
                    <th class="header-cell w5">Route Id</th>
                    <th class="header-cell w5">Route Desc</th>
                    <th class="header-cell w5">Dispatcher</th>
                    <th class="header-cell w5">End Outlet</th>
                    <th class="header-cell w5">Disabled</th>
                    <th class="header-cell w5">CCIC Group</th>
                    <th class="header-cell w5">CCIC Mail To</th>
                    <th class="header-cell w5">CCIC Mail CC</th>
                    <th class="header-cell w5">CCIC Team</th>
                    <th class="header-cell w5">CCIC Team Remark</th>
                    <th class="header-cell w5">CCIC Role</th>
                    <th class="header-cell w5">CCIC User Alias</th>
                    <th class="header-cell w5">Create Person</th>
                    <th class="header-cell w5">Create Date</th>
                    <th class="header-cell w5">Create Time</th>
                    <th class="header-cell w5">Change Person</th>
                    <th class="header-cell w5">Change Date</th>
                    <th class="header-cell w5">Change Time</th>
                  </tr>
                  </thead>
                </table>
              </div>
              <div class="table-body " @scroll="handleScroll">
                <table id="bodytable">
                  <tbody>
                  <tr v-for="item in pageItems" :key="item.username">
                    <td class="body-cell w5" v-if="getPermission.users.edit">
                      <md-button @click="toggleUpdate(item)" class="md-icon-button">
                        <md-icon>mode_edit</md-icon>
                      </md-button>
                      <md-button @click="toggleReset(item)" class="md-icon-button">
                        <md-icon>info_outline</md-icon>
                        <md-tooltip md-delay="300">Reset Password</md-tooltip>
                      </md-button>
                    </td>
                    <td class="body-cell w10">{{item.username}}</td>
                    <td class="body-cell w3">
                      <md-checkbox v-model="item.loginWithMFA" disabled></md-checkbox>
                    </td>
                    <td class="body-cell w10">{{item.name}}</td>
                    <td class="body-cell w5">
                      <master-data-display group="UserCategory" :tag-id="item.category"/>
                    </td>
                    <td class="body-cell w10">{{item.companyName}}</td>
                    <td class="body-cell w5">{{item.country}}</td>
                    <td class="body-cell w5">{{item.mobileNo}}</td>
                    <td class="body-cell w7">{{item.mfaMobileNo}}</td>
                    <td class="body-cell w10">{{item.email}}</td>
                    <td class="body-cell w10">{{item.defaultSalesOffice}}</td>
                    <td class="body-cell w10">{{item.recWindow}}</td>
                    <td class="body-cell w5">{{item.driverGroup}}</td>
                    <td class="body-cell w5">{{item.driverRegion}}</td>
                    <td class="body-cell w5">{{item.routeId}}</td>
                    <td class="body-cell w5">{{item.routeDesc}}</td>
                    <td class="body-cell w5">{{item.dispatcher}}</td>
                    <td class="body-cell w5">{{item.endOutlet}}</td>
                    <td class="body-cell w5">
                      <md-checkbox disabled v-model="item.disabled"/>
                    </td>
                    <td class="body-cell w5">{{item.ccicSupplierGroup}}</td>
                    <td class="body-cell w5">
                      <div>
                        {{!!item.ccicEmailTo ? `${item.ccicEmailTo.split(';').length} email` : ''}}
                        <md-tooltip md-delay="300">{{item.ccicEmailTo}}</md-tooltip>
                      </div>
                    </td>
                    <td class="body-cell w5">
                      <div>
                        {{!!item.ccicEmailCc ? `${item.ccicEmailCc.split(';').length} email` : ''}}
                        <md-tooltip md-delay="300">{{item.ccicEmailCc}}</md-tooltip>
                      </div>
                    </td>
                    <td class="body-cell w5">
                      <div v-for="t in item.ccicTeams" :key="t.tagId">
                        <master-data-display group="CCIC_TEAM" :tag-id="t"/>
                      </div>
                    </td>
                    <td class="body-cell w5">
                      {{item.ccicTeamRemark}}
                    </td>
                    <td class="body-cell w5">
                      <master-data-display group="CCIC_ROLE" :tag-id="item.ccicRole"/>
                    </td>
                    <td class="body-cell w5">
                      {{item.ccicUserAlias}}
                    </td>
                    <td class="body-cell w5">{{item.createdBy}}</td>
                    <td class="body-cell w5">{{item.createdAt | date}}</td>
                    <td class="body-cell w5">{{item.createdAt | time}}</td>
                    <td class="body-cell w5">{{item.updatedBy}}</td>
                    <td class="body-cell w5">{{item.updatedAt | date}}</td>
                    <td class="body-cell w5">{{item.updatedAt | time}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </md-card>
      </template>
    </pagination>
  -->
  </div>
</template>

<style scoped>
  .MFA {
    height: 300px; width:95%; 
    border: 5px solid rgb(167, 175, 151); 
    border-radius: 10px; 
    background-color: rgb(243, 239, 234);
    margin-left: 25px;
    margin-bottom: 15px;
  }
  .MFAQR {
    margin-top: 45px; 
    margin-left: 150px; 
    height: 300px; 
    width: 300px;
  }
  .QRCodeText {
    background: lightgreen;
    width: 600px;
    height: 35px;
    padding: 5px;
    margin-top: 80px;
    margin-left: 15px;
    justify-content: center;
    align-items: center;
    display: flex;
    font-size: 20px;
    color: rgb(207, 67, 67);
    border-radius: 5px;
    border-right: 3px solid gray;
    border-bottom: 3px solid gray;
  }
  .MFAContent {
    width: 500px;
    margin-top: 10px;
    margin-left: 20px;
  }
  .MFAInnerBox {
    margin-top: 15px;
  }
  .MFAHeader {
    justify-content: center;
    align-items: center;
    display: flex;
    font-size: 28px;
    height: 50px;
    background: rgb(64, 139, 64);
    
    color: white;
  }
  .MFAInfo {
    font-size: 25px;
  }
  .UserButtons {
    float: left;
    margin-top: 5px;
    margin-left: 10px;
  }
  .MFAEnabled {
    margin-left: 10px;
    margin-top: 35px;
    color: blue;
  }
  .UserPreference {
    color: red !important;
  }
</style>

<script>
  import { mapGetters } from 'vuex';
  //import Amplify, { Auth } from 'aws-amplify';
  import { getCurrentUser, fetchUserAttributes, setUpTOTP } from 'aws-amplify/auth';
  import { verifyTOTPSetup, updateMFAPreference, fetchMFAPreference } from 'aws-amplify/auth';
  import UserForm from '../components/UserForm.vue';
  import { sortList } from '../utils/sort';
  import toGenerateExcelRequest from '../utils/excel';
  import dateFormat from "../utils/dateFormat";
  import QrcodeVue from 'qrcode.vue';
  import { newAPIPost } from '../api/index.js';
  //import auth from '../vuex/auth';


  const getInitSearchRequest = () => ({
    fromUsername: null,
    toUsername: null,
    category: null,
    companyId: null,
    driverGroup: null,
  });

  const initTOTPAuth = () => ({
    secretCode: null,
    awsSecretCode: null,
    otpauthURL: null,
    userMFAPreference: null,
  });

  const updateMFAEnable = () => ({
    username: null,
    loginWithMFA: false,
    mfaEnableOnly: true,
  });

  export default {
    data: () => ({
      searchRequest: getInitSearchRequest(),
      dialog: {
        isShowing: false,
      },
      showDisabled: false,
      sort: {
        field: `username`,
        ascending: true,
      },
      authForm: initTOTPAuth(),
      updateMFAEnable: updateMFAEnable(),
      authenticatedUser: null,
      UserMFAEnabled: true,
      disableGenTOTP: true,
      userMFAMethod: null,
    }),
    components: {
      UserForm,
      QrcodeVue,
    },
    computed: {
      ...mapGetters([
        'getUsers',
        'getMasterDataByGroup',
        'getMasterDataName',
        'getPermission',
      ]),
      getUsersToDisplay() {
        const fn = () => {
          if (this.showDisabled) {
            return this.getUsers;
          }
          return _(this.getUsers)
            .filter(it => !it.disabled);
        };
        return sortList(fn(), this.sort);
      },
    },
    async mounted() {
      const cachedSearchRequest = this.$store.state.user.searchUserRequest;
      if (cachedSearchRequest) {
        this.searchRequest = cachedSearchRequest;
      }
      //this.authenticatedUser = Auth.currentAuthenticatedUser();
      this.authenticatedUser = await getCurrentUser();
      if (this.getUsersToDisplay == null || this.getUsersToDisplay.length <= 0)
      {
          await this.$store.dispatch('loadUsers');
      }
    
      console.log(`get user to display: ${JSON.stringify(this.getUsersToDisplay)}`);
      console.log(`authenticated username: ${this.authenticatedUser.username}`);
      const loginuser = this.getUsersToDisplay.filter(it => it.username == this.authenticatedUser.username);

      console.log(`login user: ${JSON.stringify(loginuser)}`);
      if (loginuser && loginuser.length > 0 && (loginuser[0].mfaMethod != null && loginuser[0].mfaMethod != ''))
      {
          this.userMFAMethod = loginuser[0].mfaMethod;
          console.log(`userMFAMethod1: ${this.userMFAMethod}`);
      }
      if (loginuser && loginuser.length > 0 && loginuser[0].firstTimeTOTP && loginuser[0].firstTimeTOTP == true)
      {
         this.disableGenTOTP = false;
      } else {
         this.disableGenTOTP = true;
      }
      this.doGetUserMFAPreference();
    },
    methods: {
      handleScroll(e) {
        if (this.$el) {
          $(this.$el.querySelector('.table-header'))
            .offset({
              left: -1 * (e.target.scrollLeft - $('.outer-container')
                .offset().left)
            });
        }
      },
      toggleCreate() {
        this.$refs.CreateForm.openDialog();
      },
      toggleUpdate(user) {
        console.log(`toggleUpdate`, user);
        this.$refs.UpdateForm.openDialog(user);
      },
      toggleReset(user) {
        console.log(`toggleUpdate`, user);
        this.$refs.ResetForm.openDialog(user);
      },
      doSearch() {
        if (this.searchRequest.category === '') {
          this.searchRequest.category = null;
        }
        this.$store.dispatch('loadUsers', this.searchRequest);
      },
      clearSearch() {
        this.$nextTick(() => {
          this.searchRequest = getInitSearchRequest();
        });
      },
      doClear() {
        this.authForm.secretCode = null;
        this.authForm.otpauthURL = '';
        this.doGetUserMFAPreference(); 
      },
      async doSetupTOTP()
      {
         console.log(`calling dosetuptotp`);
         //const user = await Auth.currentAuthenticatedUser();
         //this.authForm.awsSecretCode = await Auth.setupTOTP(user);
         const totpSetupDetails = await setUpTOTP();
         const sharedSecret = totpSetupDetails.sharedSecret;
         this.authForm.awsSecretCode = sharedSecret;
         const user = await getCurrentUser();
         var issuer = "ACNI";
         const loginuser = this.getUsersToDisplay.filter(it => it.username == user.username);
         console.log(`login user: ${JSON.stringify(loginuser)}`);
         if (loginuser.companyId == '5000349')
         {
            issuer = "FSI";
         }
         
         if (loginuser.companyId == "5001416") {
            issuer = "STC";
         }
         const setupUri = totpSetupDetails.getSetupUri(issuer,user.username);
         console.log(`setupuri: ${JSON.stringify(setupUri)}`);
         const username = user.username;
         this.authForm.otpauthURL = `otpauth://totp/${issuer}:${username}?secret=${this.authForm.awsSecretCode}&issuer=${issuer}`;
         console.log(`secretcode: ${this.authForm.awsSecretCode}`);
         console.log(`otpauth: ${this.authForm.otpauthURL}`);
         //alert(`secretcode: ${this.authForm.otpauthURL}`);
      },
      async doVerifyTOTP() {
         console.log('calling doverifytotp');
         try {
            if (this.authForm.secretCode && this.authForm.secretCode != '')
            {
            //const user = await Auth.currentAuthenticatedUser();
            const user = await getCurrentUser();
            //await Auth.verifyTotpToken(user, this.authForm.secretCode);
            const p_secretCode = this.authForm.secretCode;
            await verifyTOTPSetup({ code: p_secretCode});
            console.log(`TOTP token verified successfully`);
            alert("Authenticator App token verified successfully");
            //await Auth.setPreferredMFA(user, "TOTP");
            //await updateMFAPreference({ email: 'NOT_SET'});
            //await updateMFAPreference({ sms: 'NOT_SET'});
            await updateMFAPreference({ totp: 'PREFERRED'});
            //const user = await getCurrentUser();
            const mode = 'UPDATE';
            await newAPIPost('/api/w/users/update',{username: user.username, fistTimeTOTP: false, onlyForFirstTimeTOTP: true, action: mode});
            this.disableGenTOTP = true;
            this.doGetUserMFAPreference();
            } else {
               console.log('Not process with empty secret code!');
               alert('Not process with empty secret code!');
            }
         } catch (error) {
            console.log(`Error verifying TOTP setup: ${error}`)
         }
      },
      async doGetUserMFAPreference() {
         console.log('calling dogetusermfapreference');
         try {
            const mfaInfo = await fetchMFAPreference();
            //const mfaMethod = mfaInfo.enabled;
            const mfaMethod = mfaInfo.preferred;
            console.log(`Preferred MFA: ${JSON.stringify(mfaInfo)}`);
            console.log(`mfa endable: ${mfaMethod}}`);
            //console.log(`Enabled MFA methods: ${enabledMfaMethods}`);

            //const userAttributes = await fetchUserAttributes();
            //console.log(`user attributes: ${JSON.stringify(userAttributes)}`);
            this.authForm.userMFAPreference = 'NO MFA';
            this.UserMFAEnabled = false;
            //this.disableGenTOTP = false;
            //if (userAttributes['custom:preferredMfa']) {
            if (mfaMethod == 'EMAIL') {
               //console.log(`Preferred MFA: ${userAttributes['custom:preferredMfa']}`);
               console.log(`mfaMethod: ${mfaMethod} userMFAMethod: ${this.userMFAMethod}`);
               if (mfaMethod != this.userMFAMethod)
               {
                  if (this.userMFAMethod == 'TOTP')
                  {
                      this.authForm.userMFAPreference = 'AUTHENTICATOR APP';   
                  } else {
                      this.authForm.userMFAPreference = this.mfaMethod;
                  }
               } else {
                  this.authForm.userMFAPreference = 'EMAIL';
               }
               this.UserMFAEnabled = true; 
               //this.disableGenTOTP = false; 
            }
            //if (userAttributes.phone_number_verified && userAttributes['cognito:mfa_methods']?.includes('SMS')) {
            if (mfaMethod == 'SMS') {
               console.log('SMS MFA is endabled');
               this.authForm.userMFAPreference = 'MOBILE SMS';
               this.UserMFAEnabled = true; 
               //this.disableGenTOTP = false; 

            }
            //if (userAttributes['cognito:mfa_methods']?.includes('SOFTWARE_TOKEN_MFA')) {
            if (mfaMethod == 'TOTP') {
               console.log('TOTP MFA is enabled');
               if ((mfaMethod != this.userMFAMethod))
               {
                  this.authForm.userMFAPreference = this.userMFAMethod;
               } else {
                  this.authForm.userMFAPreference = 'AUTHENTICATOR APP';
               }
               this.UserMFAEnabled = true; 
               //this.disableGenTOTP = true; 
           }



            // const user = await Auth.currentAuthenticatedUser();
            // const preferredMFA = user.preferredMFA;
            // //this.UserMFAEndabled = user.mfa_endabled;
            // const checkusermfa = await Auth.getPreferredMFA(user);
            // console.log(`user mfa enabled: ${JSON.stringify(checkusermfa)}`);
            // //var p_preferredMFA = preferredMFA;
            // var p_preferredMFA = checkusermfa;
            // if (p_preferredMFA == null || p_preferredMFA == '')
            // {
            //     if (checkusermfa && checkusermfa != '')
            //     {
            //         p_preferredMFA = checkusermfa;
            //     }
            // }
            // if (p_preferredMFA == 'SMS_MFA')
            // {
            //    this.authForm.userMFAPreference = 'MOBILE SMS';
            //    this.UserMFAEnabled = true; 
            //    this.disableGenTOTP = false; 
            // } else if (p_preferredMFA == 'SOFTWARE_TOKEN_MFA')
            // {
            //    console.log(`this is authenticator App: ${JSON.stringify(p_preferredMFA)}`);
            //    this.authForm.userMFAPreference = 'AUTHENTICATOR APP';
            //    this.UserMFAEnabled = true; 
            //    this.disableGenTOTP = true; 
            // } else {
            //    this.authForm.userMFAPreference = preferredMFA;
            //    this.UserMFAEnabled = false;
            //    this.disableGenTOTP = false; 
            // }
            // this.updateMFAEnable.loginWithMFA = this.UserMFAEnabled;
            // this.updateMFAEnable.mfaEnableOnly = true;
            // console.log(`user username: ${JSON.stringify(user.username)}`);
            // if (user.username != null && user.username != "")
            // {
            //    console.log(`process to update mfa`);
            //    this.updateMFAEnable.username = user.username;
            //    this.$store.dispatch("updateUser", this.updateMFAEnable);
            // }
            // //this.authForm.userMFAPreference = preferredMFA;
            // console.log(`user: ${JSON.stringify(user)}`);
         } catch (error) {
            console.log(`error find in getting the user MFA preference! ${error}`);
            alert(`error find in getting the user MFA preference!`);
         }
      },
      async doGetLoginUserInfo() {
         //const user = await Auth.currentAuthenticatedUser();
         const user = await getCurrentUser();
         const loginuser = this.getUsersToDisplay.filter(it => it.username == user.username);
         alert(`login user: ${JSON.stringify(loginuser)}`);
      },
      doHandleMFAEnable(id) {
         this.UserMFAEnabled = id;
      },
      doDownloadExcel() {
        const request = toGenerateExcelRequest(
          this.$el.querySelector('.data-table-container .inner-container'),
          'Users.xls',
          1,
        );

        request.rows = _(this.getUsersToDisplay)
          .map(item => [
            item.username,
            item.name,
            this.getMasterDataName('UserCategory', item.category),
            item.companyName,
            item.country,
            item.mobileNo,
            item.mfaMobileNo,
            item.email,
            item.defaultSalesOffice,
            item.driverGroup,
            item.driverRegion,
            item.routeId,
            item.routeDesc,
            item.dispatcher,
            item.endOutlet,
            item.disabled,
            item.ccicSupplierGroup,
            item.ccicEmailTo,
            item.ccicEmailCc,
            item.ccicTeams.join(','),
            item.ccicTeamRemark,
            item.ccicRole,
            item.ccicUserAlias,
            item.createdBy,
            dateFormat.date(item.createdAt),
            dateFormat.time(item.createdAt),
            item.updatedBy,
            dateFormat.date(item.updatedAt),
            dateFormat.time(item.updatedAt),
          ]);

        this.$store.dispatch('generateExcel', request)
          .then((res) => {
            window.open(res.url, 'blank');
          });
      },
    },
  };

</script>
